module.exports = "/_next/static/images/n11-e8e67632e43bcb1ad60a40558bc1eaf6.png";